import { NotificationEventBus } from '@trimble/solidjs-notifications';
import { t } from '@trimble/i18n';

export interface PointCloudLoadErrorNotifier {
  report(): void;
  cancel(): void;
}

const DEFAULT_COALESCE_WINDOW_MS = 500;

export function createPointCloudLoadErrorNotifier(
  coalesceWindowMs: number = DEFAULT_COALESCE_WINDOW_MS
): PointCloudLoadErrorNotifier {
  let timer: ReturnType<typeof setTimeout> | undefined;

  const flush = (): void => {
    timer = undefined;
    NotificationEventBus.emit({
      type: 'error',
      message: t('mobileMapping.projectData.pointCloudLoadFailed'),
    });
  };

  return {
    report(): void {
      if (timer !== undefined) clearTimeout(timer);
      timer = setTimeout(flush, coalesceWindowMs);
    },
    cancel(): void {
      if (timer !== undefined) {
        clearTimeout(timer);
        timer = undefined;
      }
    },
  };
}
